// extracted by css-extract-rspack-plugin
export default {"filterItemWrapper":"_e2aecc89","container":"_77e86908","value":"_8b9d71a4","closeIconWrapper":"_88448c41","truncateLabel":"_c862b7c7","colorDot":"_6fe19f4d"};